import { FieldValidation } from '@atlassian/mpac-utils';
export const ALL_DAYS_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

// eslint-disable-next-line complexity
export const checkFormValidation = data => {
  const errors = {};
  if (data.providesSupportHours) {
    if (!data.targetResponseTime) {
      errors.targetResponseTime = 'Please provide a target response time';
    } else if (FieldValidation.checkNonEmptyDigits('Target Response Time')(data.targetResponseTime.toString())) {
      errors.targetResponseTime = FieldValidation.checkNonEmptyDigits('Target Response Time')(data.targetResponseTime.toString());
    }
    if (!data.timezone.value) {
      errors.timezone = 'Please select a timezone';
    }
    if (!data.hoursOfOperation) {
      errors.hoursOfOperation = 'Please select hours of operation';
    }
    if (!data.daysOfOperation) {
      errors.daysOfOperation = 'Please select days of operation';
    } else if (data.daysOfOperation === 'custom' && data.days.length === 0) {
      errors.daysOfOperation = 'Please select your operation days';
    }
    if (!data.hoursOfOperation) {
      errors.hoursOfOperation = 'Please select hours of operation';
    } else if (data.hoursOfOperation === 'custom') {
      const fromHour = Number(data.fromHour.value);
      const untilHour = Number(data.untilHour.value);
      if (untilHour - fromHour < 1) {
        errors.hoursOfOperation = 'End time needs to be atleast one hour after your beginning time';
      }
    }
  }
  if (Object.keys(errors).length > 0) {
    return errors;
  }
};
export const getSupportFieldsFromFormData = data => {
  const rangeExists = data.fromHour && data.fromMinute && data.untilHour && data.untilMinute;
  const range = rangeExists ? {
    from: "".concat(data.fromHour.value, ":").concat(data.fromMinute.value, ":00"),
    until: "".concat(data.untilHour.value, ":").concat(data.untilMinute.value, ":00")
  } : undefined;
  const timezone = data.timezone.value;
  const supportHours = {
    timezone,
    range,
    days: data.daysOfOperation === 'custom' ? data.days : ALL_DAYS_OF_WEEK,
    holidays: data.holidays ? data.holidays : []
  };
  return supportHours;
};